import learnLibraries from './learnLibraries.js';
import { onDOMContentLoaded } from '../../dom/events';

onDOMContentLoaded(() => learnLibraries.init());